import React from 'react';
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import ToggleButton from "react-toggle-button";
import { themeCSSConstants } from 'redux/constant/themeCSS';
import DatePicker from "react-datepicker";

class Produc extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        this.state = {
            brand_product_attributes: {
                ...this.props.brandPro,
            },
            submitted: false,
            formType: this.props.formTypePro || '',
            duplicate_error: false,
        };
        this.handleList = this.handleList.bind(this);
        this.handleListSubmitForm = this.handleListSubmitForm.bind(this);
    }
    handleList(e) {
        const { name, value } = e.target;
        this.setState(prevState => ({
            brand_product_attributes: {
                ...prevState.brand_product_attributes,
                [name]: value
            }
        }));
    }

    handleChangeState = (selectedOption, name) => {
        if (name.action === 'select-option') {
            this.setState({
                brand_product_attributes: {
                    ...this.state.brand_product_attributes,
                    [name.name]: selectedOption.value,
                }
            }, () => {
                if (name.name === 'data_type') {
                    this.setState({
                        brand_product_attributes: {
                            ...this.state.brand_product_attributes,
                            default_value: '',
                            default_value_type: ''
                        }
                    })
                }
            })
        }
    }

    onCheckFlag = (toggle, name) => {
        this.setState({
            brand_product_attributes: {
                ...this.state.brand_product_attributes,
                [name]: !toggle
            }
        }, () => {
        });
    }

    handleCheckStatus = (e) => {
        const { name, checked } = e.target;
        this.setState({
            brand_product_attributes: {
                ...this.state.brand_product_attributes,
                [name]: checked,
            }
        })
    }
    handleListSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            const filtered = this.props.attributesProp.filter(data => {
                return data.title.toLowerCase() === this.state.brand_product_attributes.title.toLowerCase()
            })
            if (filtered.length > 0) {
                this.setState({
                    duplicate_error: true
                })
                return;
            }
            const attributes = this.state.brand_product_attributes;
            const title = this.state.brand_product_attributes['title'];
            const db_column = this.state.brand_product_attributes['title'].replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase();
            attributes['title'] = title;
            attributes['db_column'] = db_column;
            this.setState({
                submitted: false
            }, function () {
                this.props.handleSubmit(this.state.brand_product_attributes, 'save');
            });
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }

    handleAddMoreAttributes = (e) => {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            const filtered = this.props.attributesProp.filter(data => {
                return data.title.toLowerCase() === this.state.brand_product_attributes.title.toLowerCase()
            })
            if (filtered.length > 0) {
                this.setState({
                    duplicate_error: true
                })
                return;
            }
            const attributes = this.state.brand_product_attributes;
            const title = this.state.brand_product_attributes['title'];
            const db_column = this.state.brand_product_attributes['title'].replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase();
            attributes['title'] = title;
            attributes['db_column'] = db_column;
            this.setState({
                submitted: true,
                duplicate_error: false
            }, function () {
                this.props.handleSubmit(this.state.brand_product_attributes, 'add_more');
                this.setState({
                    brand_product_attributes: {
                        ...this.props.brandPro,
                    },
                    submitted: false,
                    formType: this.props.formTypePro || '',
                    duplicate_error: false,
                })
            });
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.brand_product_attributes !== prevState.brand_product_attributes && this.state.duplicate_error) {
            if (this.state.brand_product_attributes.title !== prevState.brand_product_attributes.title) {
                this.setState({
                    duplicate_error: false
                })
            }
        }
    }


    dateChangeHandler = (name, date) => {
        this.setState({
            brand_product_attributes: {
                ...this.state.brand_product_attributes,
                default_value: date
            }
        })
    }


    render() {
        if (this.state.submitted) {
            this.valitdatorList.hideMessages();
        }
        this.valitdatorList.purgeFields();
        const { brand_product_attributes } = this.state;
        return (
            <form onSubmit={this.handleListSubmitForm}>
                <div className="row setMinHeight">
                    <div className="col-md-2 col-sm-4">
                        <div className='form-group'>
                            <label className="mb-xs" htmlFor="title">Title<span className="requiredClass">*</span></label>
                            <input type="text" name="title" className="form-control" value={brand_product_attributes.title} onChange={this.handleList} />
                            {this.state.duplicate_error && <span style={{ color: 'red' }}>Title already exists in the list.</span>}
                            {this.valitdatorList.message('Title', brand_product_attributes.title, 'required')}
                        </div>
                    </div>

                    <div className="col-md-2 col-sm-4">
                        <div className='form-group'>
                            <label className="mb-xs" htmlFor="sample_value">Sample Value<span className="requiredClass">*</span></label>
                            <input type="text" name="sample_value" className="form-control" value={brand_product_attributes.sample_value} onChange={this.handleList} />
                        </div>
                    </div>

                    <div className="col-md-2 col-sm-4">
                        <div className='form-group'>
                            <label className="mb-xs" htmlFor="grid_label">Grid Label<span className="requiredClass">*</span></label>
                            <input type="text" name="grid_label" className="form-control" value={brand_product_attributes.grid_label} onChange={this.handleList} />
                            {this.valitdatorList.message('Cart Label', brand_product_attributes.grid_label, 'required')}
                        </div>
                    </div>

                    {
                        (this.props.fileType === 'FIXED_LENGTH' || this.props.start_condition) &&
                        <React.Fragment>
                            <div className="col-md-2 col-sm-4">
                                <div className='form-group'>
                                    <label className="mb-xs" htmlFor="start_position">Start Position<span className="requiredClass">*</span></label>
                                    <input type="text" name="start_position" className="form-control" value={brand_product_attributes.start_position ? brand_product_attributes.start_position : ''} onChange={this.handleList} />
                                    {
                                        this.valitdatorList.message('Start Position ', brand_product_attributes.start_position, `required|integer`)}
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-4">
                                <div className='form-group'>
                                    <label className="mb-xs" htmlFor="end_position">End Position<span className="requiredClass">*</span></label>
                                    <input type="text" name="end_position" className="form-control" value={brand_product_attributes.end_position ? brand_product_attributes.end_position : ''} onChange={this.handleList} />
                                    {this.valitdatorList.message('End Position', brand_product_attributes.end_position, `required|integer|min:${brand_product_attributes.start_position},num`)}
                                </div>
                            </div>
                        </React.Fragment>
                    }

                    <div className="col-md-2 col-sm-4">
                        <label className="mb-xs" htmlFor="data_type">Data Type<span className="requiredClass">*</span></label>
                        <React.Fragment>
                            <Select
                                value={HF.returnLabelWithValue(this.state.brand_product_attributes.data_type, OC.dataTypeList)}
                                onChange={this.handleChangeState}
                                options={OC.dataTypeList}
                                isSearchable={true}
                                name={'data_type'}
                                isMulti={false}
                                placeholder={'Data Type'}
                                isClearable={false}
                            />
                            {this.valitdatorList.message('Datatype', brand_product_attributes.data_type, `required`)}
                        </React.Fragment>
                        {
                            this.state.brand_product_attributes.data_type === 'datetime' &&
                            <React.Fragment>
                                <label className="mt-xs" htmlFor="data_type">Date Format<span className="requiredClass">*</span></label>
                                <Select
                                    value={HF.returnLabelWithValue(this.state.brand_product_attributes.date_format, OC.DATE_FORMATS)}
                                    onChange={this.handleChangeState}
                                    options={OC.DATE_FORMATS}
                                    isSearchable={true}
                                    name={'date_format'}
                                    isMulti={false}
                                    placeholder={'Date Format'}
                                    className='mt-xs'
                                    isClearable={false}
                                />
                            </React.Fragment>
                        }
                    </div>

                    <div className="col-md-2 col-sm-4">
                        {
                            brand_product_attributes['data_type'] === 'datetime' ?
                                <React.Fragment>
                                    <label className="mb-xs" htmlFor="data_type">Default Type<span className="requiredClass">*</span></label>
                                    <Select
                                        value={HF.returnLabelWithValue(this.state.brand_product_attributes.default_value_type, OC.DEFAULT_DATE_OPTIONS)}
                                        onChange={this.handleChangeState}
                                        options={OC.DEFAULT_DATE_OPTIONS}
                                        isSearchable={true}
                                        name={'default_value_type'}
                                        isMulti={false}
                                        placeholder={'Select Default'}
                                        isClearable={false}
                                    />
                                </React.Fragment>
                                :
                                <div>
                                    <label className="mb-xs" htmlFor="default_value">Default Value</label>
                                    <input type="text" name="default_value" className="form-control" value={brand_product_attributes.default_value} onChange={this.handleList} />
                                </div>
                        }
                        {
                            (brand_product_attributes['default_value_type'] === 'pick_date' && brand_product_attributes['data_type'] === 'datetime' && brand_product_attributes['default_value_type']) &&
                            <div>
                                <label className="mt-xs mb-xs" htmlFor="data_type">Default Type<span className="requiredClass">*</span></label>
                                <DatePicker className="form-control" name='default_value' selected={brand_product_attributes['default_value'] ?
                                    Date.parse(brand_product_attributes['default_value']) : Date.now()} onChange={(event) => { this.dateChangeHandler('default_value', event) }} autoComplete='off' />
                            </div>
                        }
                    </div>
                    <div className='col-md-12'>
                        <div className="row">

                            <div className="col-md-2 col-sm-4 col-xs-6">
                                <div className='form-group labelMargin'>
                                    <label htmlFor="show_on_grid">Show on Grid<span className="requiredClass">*</span></label>
                                    <ToggleButton
                                        inactiveLabel={''}
                                        activeLabel={''}
                                        colors={themeCSSConstants.THUMBICONSTYLE}
                                        trackStyle={themeCSSConstants.TRACKSTYLE}
                                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                                        thumbAnimateRange={[4, 30]}
                                        value={this.state.brand_product_attributes['show_on_grid']}
                                        name="show_on_grid"
                                        onToggle={(e) => this.onCheckFlag(e, 'show_on_grid')}
                                    />
                                </div>
                            </div>

                            <div className="col-md-2 col-sm-4 col-xs-6">
                                <div className='form-group labelMargin'>
                                    <label htmlFor="is_quantity_attribute">Qty Attribute<span className="requiredClass">*</span></label>
                                    <ToggleButton
                                        inactiveLabel={''}
                                        activeLabel={''}
                                        colors={themeCSSConstants.THUMBICONSTYLE}
                                        trackStyle={themeCSSConstants.TRACKSTYLE}
                                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                                        thumbAnimateRange={[4, 30]}
                                        value={this.state.brand_product_attributes['is_quantity_attribute']}
                                        name="is_quantity_attribute"
                                        onToggle={(e) => this.onCheckFlag(e, 'is_quantity_attribute')}
                                    />
                                </div>
                            </div>

                            <div className="col-md-2 col-sm-4 col-xs-6">
                                <div className='form-group labelMargin'>
                                    <label htmlFor="exportable">Allow Export<span className="requiredClass">*</span></label>
                                    <ToggleButton
                                        inactiveLabel={''}
                                        activeLabel={''}
                                        colors={themeCSSConstants.THUMBICONSTYLE}
                                        trackStyle={themeCSSConstants.TRACKSTYLE}
                                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                                        thumbAnimateRange={[4, 30]}
                                        value={this.state.brand_product_attributes['exportable']}
                                        name="exportable"
                                        onToggle={(e) => this.onCheckFlag(e, 'exportable')}
                                    />
                                </div>
                            </div>

                            <div className="col-md-2 col-sm-4 col-xs-6">
                                <div className='form-group labelMargin'>
                                    <label htmlFor="searchable">Searchable<span className="requiredClass">*</span></label>
                                    <ToggleButton
                                        inactiveLabel={''}
                                        activeLabel={''}
                                        colors={themeCSSConstants.THUMBICONSTYLE}
                                        trackStyle={themeCSSConstants.TRACKSTYLE}
                                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                                        thumbAnimateRange={[4, 30]}
                                        value={this.state.brand_product_attributes['searchable']}
                                        name="searchable"
                                        onToggle={(e) => this.onCheckFlag(e, 'searchable')}
                                    />
                                </div>
                            </div>

                            <div className="col-md-2 col-sm-4 col-xs-6">
                                <div className='form-group labelMargin'>
                                    <label htmlFor="editable">Editable<span className="requiredClass">*</span></label>
                                    <ToggleButton
                                        inactiveLabel={''}
                                        activeLabel={''}
                                        colors={themeCSSConstants.THUMBICONSTYLE}
                                        trackStyle={themeCSSConstants.TRACKSTYLE}
                                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                                        thumbAnimateRange={[4, 30]}
                                        value={this.state.brand_product_attributes['editable']}
                                        name="editable"
                                        onToggle={(e) => this.onCheckFlag(e, 'editable')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Need to implement Add more and Save n close functionality */}
                <div className="row">
                    <div className="col-md-12 text-center">
                        <button type='submit' className="customBtn btnBlue mt-lg mr-sm ml-sm" >Save</button>
                        <button onClick={this.handleAddMoreAttributes} className="customBtn mt-lg btnBlack ml-sm mr-sm" >Save & Add More</button>
                    </div>
                </div>
            </form>
        );
    }
}


export default Produc;


// WEBPACK FOOTER //
// ./src/components/Admin/Brands/ProductAttributeForm.jsx